import { useEffect } from 'react';
import { IGenericSetState } from '../../../../utils/Interface/CommonInterface';
import { commonFeatures } from '../../../../apps/common/featureFlags/commonFeatures';

const { isCA13229On_AutocompleteAllowsNonOptionValues } = commonFeatures;

const useUpdateOnSelected = (
    selected: string | number | undefined,
    options: object[],
    setInputValue: IGenericSetState<string>,
    nameKey: string,
    valueKey: string | number,
    allowZeroValue?: boolean,
    shouldMatchOption?: boolean,
) => {
    useEffect(() => {
        if (selected || (allowZeroValue && selected === 0)) {
            const selectedOption = options.find(
                option => option[valueKey]?.toString() === selected?.toString(),
            );
            if (selectedOption) {
                setInputValue(selectedOption[nameKey]);
            }
        } else if (
            !isCA13229On_AutocompleteAllowsNonOptionValues ||
            (isCA13229On_AutocompleteAllowsNonOptionValues && shouldMatchOption)
        ) {
            setInputValue('');
        }
    }, [selected, options, nameKey, valueKey, setInputValue]);
};

export default useUpdateOnSelected;
